import {useMatchesMediaQuery} from '@Hooks/useIsSmallerThanBreakpoint';

const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';

/** Whether the visitor asked their system for less motion, kept current if they change it while the page is open. */
export const usePrefersReducedMotion = (): boolean => {
  return useMatchesMediaQuery(REDUCED_MOTION_MEDIA_QUERY);
};
